import { replace } from "ramda";
import { exportableFormat } from "./FieldTypesExportable.format";
import { FluidForm } from "./FluidForm";
import { mapKeys, mergeFormData } from "./utils/utils";
export const DEFAULT_SUCCESS_VALIDATION_RESULT = {
    fieldValidations: {},
    status: "success"
};
export function convertStructuredDataToSubmission(service, structuredData, fieldPath = "") {
    let flatData = {};
    for (let key in structuredData) {
        let path = fieldPath ? `${fieldPath}.${key}` : key;
        let fieldConfig = service.getConfig(path);
        if (!fieldConfig) {
            console.error(`Field config not found for path ${path}`);
            continue;
        }
        if (fieldConfig.type === "composedList") {
            if (!Array.isArray(structuredData[key])) {
                console.error(`Structured data for composed-list field ${path} is not an array`);
                flatData[key] = [];
                continue;
            }
            flatData[key] = structuredData[key].map((item, index) => {
                let flatItem = convertStructuredDataToSubmission(service, item, path);
                return flatItem;
            });
        }
        else {
            flatData[key] = exportableFormat(structuredData[key], fieldConfig);
        }
    }
    return flatData;
}
export function errorCount(validationResults) {
    return Object.values(validationResults.fieldValidations).filter(v => v.type !== "correct").length;
}
export function mapInferredData(form, validationResults) {
    let formCopy = new FluidForm(form.config, form.getFormSubmission());
    for (let validation of Object.values(validationResults)) {
        if (validation.inferredData) {
            //Ignore file type and file uri
            if (form.getFieldConfigByFieldPath(validation.fieldPath)?.type !== "file") {
                formCopy.setValue(validation.fieldPath, validation.inferredData);
            }
        }
    }
    return formCopy.getFormSubmission();
}
export function toValidationResultRecord(validationResults) {
    if (!validationResults) {
        return undefined;
    }
    return {
        status: validationResults.status,
        fieldValidations: mapKeys(replace('.', '/'), validationResults.fieldValidations),
        inferredData: validationResults.inferredData
    };
}
export function fromValidationResultRecord(validationResultRecord) {
    if (!validationResultRecord) {
        return undefined;
    }
    return {
        status: getValidationStatus(validationResultRecord),
        fieldValidations: mapKeys(replace('/', '.'), validationResultRecord.fieldValidations),
        inferredData: validationResultRecord.inferredData
    };
}
export function getValidationStatus(validationResults) {
    return Object.values(validationResults.fieldValidations || {}).every((validation) => validation.type === "correct") ? "success" : "error";
}
export function mergeValidationResults(existingValidationResults, newValidationResults) {
    if (!existingValidationResults) {
        return newValidationResults;
    }
    let mergedValidationResults = {
        status: existingValidationResults.status,
        fieldValidations: {
            ...existingValidationResults.fieldValidations,
            ...newValidationResults.fieldValidations
        },
        inferredData: mergeFormData(existingValidationResults.inferredData, newValidationResults.inferredData)
    };
    //update status
    mergedValidationResults.status = getValidationStatus(mergedValidationResults);
    return mergedValidationResults;
}
